import { call } from '@advanza/api'
import { LoadingDots, PreIcon } from '@advanza/ui'
import queryString from 'query-string'
import React, { useState } from 'react'

const ProvidersExportButton = ({ filter = {} }) => {
    const [isLoading, setIsLoading] = useState(false)
    const [response, setResponse] = useState(null)
    const { page, pageNr, ...restFilter } = filter
    const onExport = () => {
        if (!isLoading) {
            setIsLoading(true)
            const exportParams = { ...restFilter, noLimit: true }
            call(
                `office/providers/export/?
                ${queryString.stringify(exportParams, { arrayFormat: 'bracket' })}`,
            )
                .then(setResponse, setResponse)
                .finally(() => setIsLoading(false))
        }
    }
    const iconName = (() => {
        if (isLoading) {
            return 'hourglass_full'
        }
        if (response && response.scheduled) {
            return 'sentiment_very_satisfied'
        }
        return 'file_download'
    })()
    const buttonContent = (() => {
        if (isLoading) {
            return <LoadingDots />
        }
        if (!response) {
            return 'Export sheet'
        }
        return response.scheduled ? 'Scheduled export task' : 'Error'
    })()
    return (
        <button onClick={onExport}>
            <PreIcon name={iconName}>{buttonContent}</PreIcon>
        </button>
    )
}

export default ProvidersExportButton
